import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useGlue } from './useGlue';
import { useEffect, useState } from 'react';
import { GlueEvents } from '../glue';
export var useAuthentication = function useAuthentication() {
  var glue = useGlue();

  var _useState = useState(glue.authentication),
      _useState2 = _slicedToArray(_useState, 2),
      authentication = _useState2[0],
      setAuth = _useState2[1];

  useEffect(function () {
    return glue.on(GlueEvents.AUTHENTICATION_SETUP, function (auth) {
      setAuth(auth);
    });
  });
  return authentication;
};